/**
 * Sports Realm — hero slider.
 *
 * Reproduces the approved mockup's interaction model exactly and nothing more:
 *   autoplay (default 6500ms) · prev/next · pagination dots · zero-padded counter
 *   · touch swipe (50px threshold) · arrow keys while the hero is in view
 *   · pause on hover, re-arm after any interaction · honours prefers-reduced-motion.
 *
 * No dependencies. Disabled slides never reach the DOM (Liquid omits hidden blocks),
 * so this only ever sees live slides.
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initHero(root) {
    if (!root || root.dataset.srHeroReady === 'true') return;

    var track = root.querySelector('[data-sr-hero-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-sr-slide]')) : [];
    if (slides.length === 0) return;

    var dotsWrap = root.querySelector('[data-sr-hero-dots]');
    var countEl = root.querySelector('[data-sr-hero-count]');
    var prevBtn = root.querySelector('[data-sr-hero-prev]');
    var nextBtn = root.querySelector('[data-sr-hero-next]');

    var autoplay = root.dataset.autoplay === 'true' && !REDUCE;
    var delay = parseInt(root.dataset.autoplaySpeed, 10) || 6500;
    var index = 0;
    var timer = null;
    var dots = [];

    /* ---- Dots ---- */
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sr-hero__dot-btn' + (i === 0 ? ' sr-is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        if (slide.dataset.accent) dot.dataset.accent = slide.dataset.accent;
        dot.addEventListener('click', function () {
          go(i);
          rearm();
        });
        dotsWrap.appendChild(dot);
      });
      dots = Array.prototype.slice.call(dotsWrap.children);
    }

    /* ---- Navigation ---- */
    function go(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('sr-is-active', on);
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === index;
        d.classList.toggle('sr-is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (countEl) {
        countEl.innerHTML = '<b>' + pad(index + 1) + '</b> / ' + pad(slides.length);
      }
    }

    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    function rearm() {
      if (timer) clearInterval(timer);
      if (autoplay && slides.length > 1) timer = setInterval(next, delay);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); rearm(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); rearm(); });

    /* ---- Pause on hover ---- */
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', rearm);

    /* ---- Touch swipe ---- */
    var startX = 0;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) {
        dx < 0 ? next() : prev();
        rearm();
      }
    }, { passive: true });

    /* ---- Arrow keys while the hero is on screen ---- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var r = root.getBoundingClientRect();
      if (r.bottom < 120 || r.top > window.innerHeight) return;
      if (e.key === 'ArrowRight') next(); else prev();
      rearm();
    });

    /* ---- Theme editor: selecting a slide block jumps to it ---- */
    root.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) {
        go(i);
        if (timer) clearInterval(timer);
      }
    });
    root.addEventListener('shopify:block:deselect', rearm);

    root.dataset.srHeroReady = 'true';
    go(0);
    rearm();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sr-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
